function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  transform: "rotate(-180 16 16)",
  fill: "#4F4F4F"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.834 21.048a.715.715 0 00.006-1.006l-3.325-3.33h12.654a.708.708 0 00.706-.712.708.708 0 00-.706-.71H10.52l3.325-3.331a.72.72 0 00-.005-1.006.708.708 0 00-1 .005l-4.507 4.54a.798.798 0 00-.148.223.713.713 0 00.148.771l4.506 4.54c.268.284.716.29.995.016z",
  fill: "#fff"
});

function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgBack;